import { BaseModel } from 'app/core/_base/crud';
export class DashboardExpiryModel extends BaseModel {
    idhh        : number
    mahh        : string
    tenhh       : string
    dvt         : number
    tendvt      : string
    idlo        : number
    tenlo       : string
    ngaysanxuat : string
    hansudung   : string
    ngayconlai  : string
    soluong     : number
	tagkho	    : string
    clear() {
        this.idhh       = 0
        this.mahh       = ""
        this.tenhh      = ""
        this.dvt        = 0
        this.tendvt     = ""
        this.idlo       = 0
        this.tenlo      = ""
        this.ngaysanxuat= ""
        this.hansudung  = ""
        this.soluong    = 0
		this.ngayconlai = ""
		this.tagkho     = ""
    }
    copy(item: DashboardExpiryModel) {
        this.idhh       = item.idhh
        this.mahh       = item.mahh
        this.tenhh      = item.tenhh
        this.dvt        = item.dvt
        this.tendvt     = item.tendvt
        this.idlo       = item.idlo
        this.tenlo      = item.tenlo
        this.ngaysanxuat= item.ngaysanxuat
        this.hansudung  = item.hansudung
        this.soluong    = item.soluong
		this.ngayconlai = item.ngayconlai
		this.tagkho     = item.tagkho
    }
}

export class DashboardExpiryColumns {
    static columns = [
        {
			stt: 1,
			name: 'stt',
			displayName: 'STT',
			alwaysChecked: false,
			isShow: true
		},
        {
			stt: 2,
			name: 'ma',
			displayName: 'Mã hàng',
			alwaysChecked: false,
			isShow: true
		},
        {
			stt: 3,
			name: 'ten',
			displayName: 'Tên hàng',
			alwaysChecked: false,
			isShow: true
		},
        {
			stt: 4,
			name: 'dvt',
			displayName: 'ĐVT',
			alwaysChecked: false,
			isShow: true
		},
        {
			stt: 5,
			name: 'lot',
			displayName: 'LOT',
			alwaysChecked: false,
			isShow: true
		},
        {
			stt: 6,
			name: 'nsx',
			displayName: 'Ngày sản xuất',
			alwaysChecked: false,
			isShow: true
		},
        {
			stt: 7,
			name: 'hsd',
			displayName: 'Hạn sử dụng',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 8,
			name: 'soluongton',
			displayName: 'Số lượng tồn',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 9,
			name: 'tenkho',
			displayName: 'Tên kho',
			alwaysChecked: false,
			isShow: true
		},
		{
			stt: 10,
			name: 'tagkho',
			displayName: 'Tag kho',
			alwaysChecked: false,
			isShow: true
		},
        {
			stt: 11,
			name: 'ngayconlai',
			displayName: 'Còn lại',
			alwaysChecked: false,
			isShow: true
		}
    ]
	static search = [
		{objCode : "MA", 	objKey : "mahh",	objValue : "Mã hàng",  	objType: "text"},
		{objCode : "TEN", 	objKey : "tenhh",	objValue : "Tên hàng",	objType: "text"},
		{objCode : "DVT", 	objKey : "tendvt",	objValue : "ĐVT", 	   	objType: "text"},
		{objCode : "LOT", 	objKey : "tenlo",	objValue : "LOT", 	   	objType: "text"},
	]
	static searchBetween = [
		{objCode : "NSXFrom", 	objKey : "ngaysanxuat",	objValue : "NSX Từ",	objType: "date", 	objPK: 1, 	objPrior: 1},
		{objCode : "NSXTo", 	objKey : "ngaysanxuat",	objValue : "NSX Đến",	objType: "date", 	objPK: 1,	objPrior: 2},
		{objCode : "HSDFrom", 	objKey : "hansudung",	objValue : "HSD Từ",	objType: "date", 	objPK: 2,	objPrior: 1},
		{objCode : "HSDTo", 	objKey : "hansudung",	objValue : "HSD Đến",	objType: "date",	objPK: 2, 	objPrior: 2},
	]
	static title = "Cảnh báo hàng sắp hết hạn sử dụng";
}
